// TODO: Import React module
import * as React from 'react';

// TODO: Import MUI module
import { Typography } from '@mui/material';

// TODO: Import MUI icon

// TODO: Import context
import { Context } from '../Common/Context';
import { Text } from '../Common/Text';

// TODO: Import custom component
import Slide from './Slide_S1Admission.jpg';
import BoxVideo from './S1Application/BoxVideo';
import BoxDocument from './S1Registration/BoxDocument';

import BoxSubPage from '../Common/BoxSubPage';

const S1Registration = () => {
    if (window.location.href.startsWith('http://localhost')) console.log('Component S1Registration Rendered');

    // TODO: Define useContext
    const context = React.useContext(Context);

    // TODO: Define variable
    const targetDate = new Date('2026-07-10T23:59:59');
    const currentDate = new Date();

    // TODO: Define event

    // TODO: Return component
    return (
        <BoxSubPage
            id="S1Admission"
            image={Slide}
            title={Text.Top.Menu['ADM'].Title[context.language]}
            subtitles={Text.Top.Menu['ADM'].Subtitles}
        >
            {/*<BoxVideo />*/}
            {currentDate < targetDate ?
                <BoxDocument /> :
                <Typography variant="body1">{Text.Common.NoDataAvailable[context.language]}</Typography>}
        </BoxSubPage>
    );
}
export default S1Registration;